<div class="min-search-wrapper">
    <input type="checkbox" class="search-box-toggler" (click)="toggle()" />
    <div class="search-box-container">
        <div class="search-box-back"></div>
        <div id="search-box-search" class="search-box-search">
            <div class="icon-container ng-star-inserted" (click)="onSearchClick($event)">
                <i class="icon"></i>
            </div>
        </div>
        <!--<input type="text" #searchBoxTerm class="search-box-term" placeholder="חיפוש" autocomplete="off" (keyup.enter)="onKeyUp($event)">-->
        <p-autoComplete #searchBoxTerm [(ngModel)]="textInInput" class="auto" [suggestions]="results" (completeMethod)="filterSearch($event)" [size]="20" placeholder="חיפוש" (keyup.enter)="onKeyUp($event)" (onSelect)="onSelect($event)">
        </p-autoComplete>
    </div>
</div>